import * as NavigationMenu from '@radix-ui/react-navigation-menu'
import * as ScrollArea from '@radix-ui/react-scroll-area'
import { space, tok, tokPx, Typography } from '@sunwebgroup/ui-components'
import { type PropsWithChildren, useState } from 'react'
import { styled } from 'styled-components'
import { MenuTrigger } from './Trigger'

const NavigationMenuContent = styled(ScrollArea.Viewport)`
  max-height: 80vh;
`

const StyledMenu = styled(NavigationMenu.Sub)`
  align-items: stretch;
  display: flex;
`

const MenuList = styled(NavigationMenu.List)`
  background: ${tok('semantics_backgrounds_tinted_background_color')};
  border-right: 1px solid ${tok('semantics_dividers_color')};
  height: 100%;
  margin: 0;
  padding: ${space('primitives_space_24')} ${space('primitives_space_40')} ${space('primitives_space_24')}
    ${space('primitives_space_24')};

  @media (min-width: ${tokPx('primitives_breakpoint_l_min')}) {
    /* This left padding is needed to create the correct size of grey background on the left, based on the size of the header */
    padding-left: calc((100vw - ${tokPx('primitives_area_size_1440')} + ${space('primitives_space_24')}) / 2);
  }

  > * ~ * {
    margin-top: ${space('primitives_space_8')};
  }
`

const MenuItem = styled(NavigationMenu.Item)`
  align-items: baseline;
  display: flex;
  & > *:first-child {
    padding: ${space('primitives_space_8')} ${space('primitives_space_24')};
  }
  &:hover ${MenuTrigger} {
    background: ${tok('primitives_color_neutral_100')};
  }

  ${Typography} {
    text-align: left;
  }
`

const MenuActiveContent = styled.div`
  align-items: stretch;
  display: flex;
  width: 100%;
`

Menu.List = MenuList
Menu.Item = MenuItem

const NavigationMenuViewport = styled(NavigationMenu.Viewport)<{ $activeItem?: string }>`
  & > :not([id$='${({ $activeItem }) => $activeItem}']) {
    display: none;
  }
`

export function Menu({ children }: PropsWithChildren) {
  const [valueMenu, setValueMenu] = useState('')
  return (
    <NavigationMenu.Content onPointerLeave={(e: React.PointerEvent) => e.preventDefault()} forceMount>
      <ScrollArea.Root>
        <NavigationMenuContent>
          <StyledMenu orientation="vertical" value={valueMenu} onValueChange={setValueMenu}>
            <MenuList>{children}</MenuList>
            <MenuActiveContent>
              <NavigationMenuViewport $activeItem={valueMenu} />
            </MenuActiveContent>
          </StyledMenu>
        </NavigationMenuContent>
        <ScrollArea.Scrollbar orientation="vertical">
          <ScrollArea.Thumb />
        </ScrollArea.Scrollbar>
      </ScrollArea.Root>
    </NavigationMenu.Content>
  )
}
